export const headerAnim = (selector) => {
   
    try {
        const products = document.querySelector('.products-header--wrapper');
        const header = document.querySelector(selector)
        window.addEventListener('scroll', function () {
            if (this.pageYOffset != 0) {
                header?.classList.add('scroll-active')
                products?.classList.add('products-header--wrapper_scroll')
            } else {
                header?.classList.remove('scroll-active')
                products?.classList.remove('products-header--wrapper_scroll')
            }
        })
    } catch (e) { }
} 
